{
  "lastUpdatedAt": "2026-10-01T12:22:47.897Z",
  "lastFetchAttemptAt": "2026-10-01T12:22:47.897Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}